module.exports = __webpack_public_path__ + "static/media/preenarm.b3db929d.jpg";